import type { WidgetEvent } from '@kunzite/shared-types';

import type { CallSessionOrchestrator } from '../call/session';

interface UaLike {
  placeCall(target: string): unknown;
}

export function createWsDispatcher(deps: { orch: CallSessionOrchestrator; ua: UaLike }): (e: WidgetEvent) => void {
  return (e) => {
    switch (e.event) {
      case 'dial':
        deps.ua.placeCall(e.data.to);
        return;
      case 'answer':
        void deps.orch.acceptIncoming();
        return;
      case 'hangup':
        deps.orch.hangup();
        return;
      case 'mute':
        deps.orch.setMuted(true);
        return;
      case 'unmute':
        deps.orch.setMuted(false);
        return;
      case 'hold':
        deps.orch.setHold(true);
        return;
      case 'unhold':
        deps.orch.setHold(false);
        return;
      case 'dtmf':
        deps.orch.sendDtmf(e.data.digit);
        return;
    }
  };
}
